// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"AuthError_inputContainer__goS33","input":"AuthError_input__29O4R","button":"AuthError_button__3cZYZ","successText":"AuthError_successText__1IZg9"};